/**
 * A single-select option marks its selection with a bare check at the end of the row. The slot is always there,
 * so the popup width does not change when the selection moves.
 */
const optionCheckStyles =
  "flex size-4 shrink-0 items-center justify-center text-[var(--fl-color-content-default-default)]"

/** A multi-select option leads with a check box, so the list reads as "pick any". */
const optionCheckboxStyles =
  "flex size-5 shrink-0 items-center justify-center rounded-[var(--fl-radius-4)] border border-[var(--fl-color-border-outlined-focus)] bg-[var(--fl-color-background-secondary-default)] text-[var(--fl-color-content-default-default)]"

export { optionCheckStyles, optionCheckboxStyles }
